

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETUSERABOUT= createAsyncThunk(
  "getUserAbout/getUserAbout",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUserAboutSlice = createSlice({
  name: "getUserAboutSlice",
  initialState: {
    getUserAbout: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUserAbout: (state) => {
        state.getUserAbout.loading = false
        state.getUserAbout.error = false
        state.getUserAbout.data = []
        state.getUserAbout.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUSERABOUT.fulfilled, (state, action) => {
      state.getUserAbout = {
        ...state.getUserAbout,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERABOUT.pending, (state, action) => {
      state.getUserAbout = {
        ...state.getUserAbout,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERABOUT.rejected, (state, action) => {
      state.getUserAbout = {
        ...state.getUserAbout,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUserAboutAction = {
    GETUSERABOUT,
};

export { getUserAboutAction };
export default getUserAboutSlice.reducer;
export const {setInitialStateOfgetUserAbout} = getUserAboutSlice.actions